import {LastCallMappersFactory} from '../Mappers/factory.js'
import {LastCallRepositoriesFactory} from '../Repositories/factory.js'
import {LastCallServicesFactory} from '../Services/factory.js'
import {CreateLastCallUseCase} from './CreateLastCallUseCase.js'
import {ShowLastCallUseCase} from './ShowLastCallUseCase.js'

export default class LastCallUseCasesFactory {
  static showLastCallUseCase = ({config}) =>
    new ShowLastCallUseCase({
      config,
      repository: LastCallRepositoriesFactory.hTTPLastCallRepository({config})
    })

  static createLastCallUseCase = ({config}) =>
    new CreateLastCallUseCase({
      config,
      fromRawParamToCreateLastCallRequestValueObjectMapper:
        LastCallMappersFactory.fromRawParamToCreateLastCallRequestValueObjectMapper({config}),
      createLastCallService: LastCallServicesFactory.createLastCallService({
        config
      })
    })
}
